import { ChangeEvent, useCallback, useState } from "react";
import { searchCustomer } from "src/apis/customerApi";
import { getEmployeeList } from "src/apis/employeeApi";


import useUiuxStore from "src/store/useUiuxStore";
import { defaultSAL1020_R01Filter, useSAL1020_R01Store } from "src/containers/mes/SAL/SAL1020_R01/Store_SAL1020_R01";

import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

export const SearchSection_SAL1020_R01 = () => {
	const { SAL1020_R01Filter, setSAL1020_R01Filter } = useSAL1020_R01Store();
	const { setCodeSearchModalProps } = useUiuxStore();
	const { compCdList } = useCommonCodeStore();
	

	// 달력 팝업 노출 여부 상태
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
	
	const custInfoHandleFoucsId = 'infoCustInput_search';
	const empInfoHandleFoucsId = 'infoEmpInput_search';

	// 사업장(회사) 선택 핸들러
	const handleFilterCompanyChange = (selectedValue: string) => {
		setSAL1020_R01Filter({ compCd: selectedValue });
	}
	
	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: SAL1020_R01Filter.customCd || '',
				customNm: SAL1020_R01Filter.customNm || '',
			}),
		},
		{
			fieldName: 'empNo',
			category: '담당자',
			focusId: empInfoHandleFoucsId,
			responseMapping: {
				empNo: 'empNo',
				empNm: 'empNm',
			},
			searchFunction: async (searchText: string) => {
				const employeeResponse = await getEmployeeList(searchText);
				return employeeResponse.data.data.find((value) => value.empNo === searchText);
			},
			extraFilter: () => ({
				empNo: SAL1020_R01Filter.empNo || '',
				empNm: SAL1020_R01Filter.empNm || '',
			}),
		},		
	];

	// Info 폼 이벤트 훅 사용 (getFieldHandlers를 먼저 가져와야 함)
	const { getFieldHandlers } = useInfoFormEvents({
		editData: SAL1020_R01Filter,
		setEditData: setSAL1020_R01Filter,
		defaultData: defaultSAL1020_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'SAL1020_R01_search'
	});

	// UI 렌더링
	return (
		<>
		<SearchSectionForm>
			{/* 사업장(회사) 선택 영역 */}
			<SearchDropDownForm
				label="사업장"
				value={SAL1020_R01Filter.compCd}
				optionList={compCdList}
				onChangeValue={handleFilterCompanyChange}
				wrapperOption={{
					wrapperStyle: "w-[200px] min-w-[200px] mr-[10px]",
					titleStyle: "w-[45px] min-w-[45px] text-left",
					selectStyle: "w-[100px] min-w-[100px]",
				}}
			/>
			<SearchDateRangeForm
				label="수주 조회 기간"
				wrapperOption={{
					titleStyle: 'h-[24px] flex items-center truncate shrink-0 w-[80px] min-w-[80px]',
				}}
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={SAL1020_R01Filter.dateRange}
				setDateRange={(dateRange) => setSAL1020_R01Filter({ dateRange: dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			{/* 거래처 입력 및 검색 영역 */}
			<SearchCodeModalForm
				label="거래처"
				value={SAL1020_R01Filter.customCd}
				valueLabel={SAL1020_R01Filter.customNm}
				handleFoucsId={custInfoHandleFoucsId}
				onChange={getFieldHandlers('customCd').onChange}
				onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
				onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
			/>
			{/* 담당자 입력 및 검색 영역 */}
			<SearchCodeModalForm
				label="담당자"
				value={SAL1020_R01Filter.empNo}
				valueLabel={SAL1020_R01Filter.empNm}
				handleFoucsId={empInfoHandleFoucsId}
				onChange={getFieldHandlers('empNo').onChange}
				onDoubleClick={getFieldHandlers('empNo').onDoubleClick}
				onKeyDown={getFieldHandlers('empNo').onEnterKeyDown}
			/>
		</SearchSectionForm>
		</>
	)
}

export default SearchSection_SAL1020_R01;

